import { render, staticRenderFns } from "./LotesList.vue?vue&type=template&id=374db9d5&"
import script from "./LotesList.vue?vue&type=script&lang=js&"
export * from "./LotesList.vue?vue&type=script&lang=js&"
import style0 from "./LotesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('374db9d5', component.options)
    } else {
      api.reload('374db9d5', component.options)
    }
    module.hot.accept("./LotesList.vue?vue&type=template&id=374db9d5&", function () {
      api.rerender('374db9d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/LotesList.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/LotesList.vue
// module id = fKkn
// module chunks = 0